import { useCallback } from "react";

import type { DiscountMultiInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { DISCOUNT_MULTI_FOR_MULTI_UPDATE_MUTATION } from "./schema";

type Props = {
	onResetViewModel: () => void;
};

export const useDiscountMultiUpdateMutation = ({ onResetViewModel }: Props) => {
	const { mutationFunc } = useCustomMutation(DISCOUNT_MULTI_FOR_MULTI_UPDATE_MUTATION);
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const onUpdateDiscountMulti = useCallback(
		async (input: DiscountMultiInput) => {
			showLoadingScreenCallback();
			const { errors } = await mutationFunc({
				variables: { input },
			}).finally(() => {
				hideLoadingScreenCallback();
			});

			if (!errors) {
				notifyUserEventInfo({
					variant: "default",
					title: "複合ディスカウントを更新しました",
				});
				onResetViewModel();
			}
		},
		[hideLoadingScreenCallback, mutationFunc, onResetViewModel, showLoadingScreenCallback],
	);

	return {
		onUpdateDiscountMulti,
	};
};
